import { Component, OnInit } from '@angular/core';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-college-images',
  standalone: true,
  imports: [
    CommonModule, // ✅ for *ngIf, *ngFor, ngStyle
    FormsModule, // ✅ for [(ngModel)]
    ReactiveFormsModule, // ✅ for reactive forms
  ],
  templateUrl: './add-college-images.component.html',
  styleUrls: ['./add-college-images.component.scss'],
})
export class AddCollegeImagesComponent implements OnInit {
  showEdit = false;
  showAdd = false;
  display: any = 'none';
  displayDelete: any = 'none';
  fileToUpload: any;
  imageUrl: any;
  collegeId: any;

  images = [];
  colleges: any;

  collegeImagesForm: UntypedFormGroup;

  showErr = false;
  deleteErr: any;

  showMore = false;

  isShowAll: boolean = false;
  clgImages: any[];
  imageData: any[] = [];
  searchval: any;

  error_messages = {
    collegeName: [{ type: 'required', message: 'Please select college name' }],
    colgImg: [{ type: 'required', message: 'Please select images' }],
  };
  allImages: any;
  id: any;
  adminName: any;
  adminImage: any;
  allCollegeImages: any;
  allData: any;

  showData = false;
  showNodata = false;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.collegeImagesForm = this.formBuilder.group({
      collegeName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),

      colgImg: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;

    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  ngOnInit(): void {
    this.collegeImagesForm.reset();
    // GET ALL COLLEGE \\
    const servicePathCollege = this.utils.getApiConfigs('college');
    // console.log("servicePathCollege",servicePathCollege);
    this.commonservice
      .invokeService(
        servicePathCollege[1].method,
        servicePathCollege[1].path,
        ''
      )
      .then((resp: any) => {
        if (resp.status_code == '200') {
          this.colleges = resp.data;
        } else if (resp.status_code == '400') {
          this.globalService.showError(resp.data);
        }
      });

    // GET ALL COLLGE IMAGES \\
    this.spinner.show();
    const servicePathImages = this.utils.getApiConfigs('allcollegeimage');
    // console.log("servicePathCollege",servicePathImages);
    this.commonservice
      .invokeService(servicePathImages[0].method, servicePathImages[0].path, '')
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.allImages = resp.data;
          // console.log("All Images", JSON.stringify(this.allImages));

          if (this.allImages == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
        this.allCollegeImages = this.allImages;

        // console.log("All colleges", this.allCollegeImages);

        for (let i = 0; i < this.allCollegeImages.length; i++) {
          // this.clgImages = this.allCollegeImages[i];
          this.allCollegeImages[i].lessData = this.allCollegeImages[
            i
          ].images.slice(0, 4);
          // console.log("clgimages", this.allCollegeImages[i]);

          // for(let j=0; j<= this.clgImages.length; j++){
          //   this.imageData = this.clgImages[j].images;
          //   console.log("imgs", this.imageData);
          // }
        }
      });
  }

  viewImages(index) {
    // console.log(index);
    if (!this.allCollegeImages[index].isShowAll) {
      this.allCollegeImages[index].lessData =
        this.allCollegeImages[index].images;
    } else {
      this.allCollegeImages[index].lessData = this.allCollegeImages[
        index
      ].images.slice(0, 4);
    }
    this.allCollegeImages[index].isShowAll =
      !this.allCollegeImages[index].isShowAll;
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", val);

    this.allData = this.allImages;

    // console.log("All Data", this.allData);

    if (val) {
      this.allCollegeImages = this.allData.filter((item) =>
        item.college_name.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allCollegeImages);
    if (this.allCollegeImages == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  openAdd() {
    this.display = 'block';
    this.collegeImagesForm.reset();
    this.images = [];
    this.showAdd = true;
    this.showEdit = false;
  }

  deleteImage(data) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }

  handleFileInput(event) {
    // console.log("event", event.target.files);

    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;

      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.images.push(event.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  addImages() {
    // console.log("Images", this.images);
    this.spinner.show();
    let payload = {
      college_id: this.collegeId,
      user_image: this.images,
    };
    // console.log("payload", JSON.stringify(payload));
    const servicePath = this.utils.getApiConfigs('collegeimage');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        // console.log("resp", resp);
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Images Added Successfully');
          this.display = 'none';
          this.ngOnInit();
          this.commonservice.refresh();
          this.collegeImagesForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletecollegeimage');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Image deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.message);
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }
}
